import ManualProduct from "./ManualProduct";
export default ManualProduct;
